import { render, staticRenderFns } from "./Icap2.vue?vue&type=template&id=4ec2163c&scoped=true&lang=true"
import script from "./Icap2.vue?vue&type=script&lang=js"
export * from "./Icap2.vue?vue&type=script&lang=js"
import style0 from "./Icap2.vue?vue&type=style&index=0&id=4ec2163c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec2163c",
  null
  
)

export default component.exports